import { motion } from 'framer-motion';
import { TimeInput } from './TimeInput';
import { ToggleSwitch } from './ToggleSwitch';
import { sectionVariants } from './settings.animations';
import styles from '../Settings.module.css';

export interface RitualSectionProps {
  shutdownTime: string;
  notifications: boolean;
  onShutdownTimeChange: (value: string) => void;
  onNotificationsChange: (value: boolean) => void;
}

export function RitualSection({
  shutdownTime,
  notifications,
  onShutdownTimeChange,
  onNotificationsChange,
}: RitualSectionProps) {
  return (
    <motion.section
      className={styles.section}
      variants={sectionVariants}
      aria-labelledby="ritual-heading"
    >
      <div className={styles.sectionHeader}>
        <span className={styles.sectionIcon} aria-hidden="true">
          ~
        </span>
        <h2 id="ritual-heading" className={styles.sectionTitle}>
          Shutdown Ritual
        </h2>
      </div>

      <div className={styles.settingRow}>
        <div className={styles.settingInfo}>
          <p className={styles.settingLabel}>Default Shutdown Time</p>
          <p className={styles.settingDesc}>When to prompt for your daily shutdown ritual</p>
        </div>
        <TimeInput value={shutdownTime} onChange={onShutdownTimeChange} label="Shutdown time" />
      </div>

      <div className={styles.settingRow}>
        <div className={styles.settingInfo}>
          <p className={styles.settingLabel}>Ritual Reminders</p>
          <p className={styles.settingDesc}>Receive notifications when it is time to shut down</p>
        </div>
        <ToggleSwitch
          checked={notifications}
          onChange={onNotificationsChange}
          label="Enable ritual reminders"
        />
      </div>
    </motion.section>
  );
}
